import { useQueryClient } from 'react-query';
import { useGetQuery } from '../useGetQuery';
import { TreasurySummary } from '../../interfaces/Treasury';

export const useTreasurySummary = () => {
    const queryClient = useQueryClient();

    const url = '/banks/connected/summary';

    const {
        isLoading,
        entries: summaryDetails,
        isFetching,
    } = useGetQuery<TreasurySummary>({
        url,
        cacheKey: `treasury-summary`,
    });
    

    const invalidateSummaryCache = () => {
        queryClient.invalidateQueries({ queryKey: ['treasury-summary'] });
    };

    return {
        isLoading,
        summaryDetails,
        invalidateSummaryCache,
        isFetching,
    };
};
